/* eslint-disable no-unused-vars */
// Swiper
// import Swiper JS
import Swiper from "swiper";

// tabs swiper
const tabsSwiper = new Swiper(".swiper.tabs-slider", {
  centeredSlides: true,
  slidesPerView: 1,
  //   loop: true,
  //   direction: "horizontal",
});

const swiperControls = document.querySelectorAll(
  ".swiper-controls .swiper-control"
);

if (swiperControls) {
  swiperControls.forEach((control) => {
    control.addEventListener("click", (ev) => {
      ev.preventDefault();
      tabsSwiper.slideTo(control.getAttribute("data-id"));
    });
  });
  tabsSwiper.on("slideChange", () => {
    const activeControl = document.querySelector(
      ".swiper-controls .swiper-control.active"
    );
    if (activeControl) {
      activeControl.classList.remove("active");
    }
    document
      .querySelector(
        ".swiper-controls .swiper-control[data-id='" +
          tabsSwiper.activeIndex +
          "']"
      )
      .classList.add("active");
  });
}
